import axios from 'axios';

import { ConfirmDialogService, ToastService } from '@iamsoftware/react-hooks';
import { AuthService } from 'src/service/AuthService';

import { signingURL } from 'src/config';
import { AgreementService } from 'src/service/AgreementService';

type SignedBy = 'SELLER' | 'BUYER';

interface SignData {
    referenceNumber?: string | null
    taxCode: string | null
    signedBy: SignedBy
    signingSecretCode: string
    restPath: string
    loginKey?: string
    agreementId?: string
    partyId?: string
    roleTypeId?: string
    pdfBase64?: string
}

export class DocumentSignService {

    static async sign(data) {
        let signingBlocks: any[] | undefined = undefined;
        let fileName: string | undefined = undefined;
        let pdfBase64: string | undefined = data.pdfBase64;
        let pulledAgreementId: string | undefined = undefined;
        let pulledPartyId: string | undefined = undefined;
        let pulledRoleTypeId: string | undefined = undefined;
        let taxCode: string | null = null;
        let isCheck: string | undefined = undefined;
        if (data.agreementId && data.partyId && data.roleTypeId) {
            try {
                const resp = await AgreementService.pullSigningData({
                    agreementId: data.agreementId,
                    partyId: data.partyId,
                    roleTypeId: data.roleTypeId,
                    referenceNumber: data.referenceNumber,
                    signingSecretCode: data.signingSecretCode
                });
                signingBlocks = resp?.signatureLocationList;
                fileName = resp?.fileName;
                pdfBase64 = resp?.base64FileData || pdfBase64;
                pulledAgreementId = (resp as any)?.agreementId || data.agreementId;
                pulledPartyId = (resp as any)?.partyId || data.partyId;
                pulledRoleTypeId = (resp as any)?.roleTypeId || data.roleTypeId;
                taxCode = (resp as any)?.partyIdValue || null;
                isCheck = (resp as any)?.isCheck || 'N';
            } catch (e: any) {
                const errorMessage = e?.response?.data?.errors || e?.response?.data?.errorMessage || e?.message || 'Không thể tải dữ liệu ký';
                ToastService.error(errorMessage);
                return { success: false, error: e, errorMessage };
            }
        } else if (data.referenceNumber && data.signingSecretCode) {
            // Trường hợp ky-hop-dong: chỉ có referenceNumber và signingSecretCode
            try {
                const resp = await AgreementService.pullSigningData({
                    agreementId: undefined,
                    partyId: undefined,
                    roleTypeId: undefined,
                    referenceNumber: data.referenceNumber,
                    signingSecretCode: data.signingSecretCode
                });
                console.log('resp', resp);
                if (!resp.errors) {
                    signingBlocks = resp?.signatureLocationList;
                    fileName = resp?.fileName;
                    pdfBase64 = resp?.base64FileData || pdfBase64;
                    pulledAgreementId = (resp as any)?.agreementId;
                    pulledPartyId = (resp as any)?.partyId;
                    pulledRoleTypeId = (resp as any)?.roleTypeId;
                    taxCode = (resp as any)?.partyIdValue;
                    isCheck = (resp as any)?.isCheck || 'N';
                } else {
                    return resp;
                }
            } catch (e: any) {
                const errorMessage = e?.response?.data?.errors || e?.response?.data?.errorMessage || e?.message || 'Không thể tải dữ liệu ký';
                ToastService.error(errorMessage);
                return { success: false, error: e, errorMessage };
            }
        }

        return axios.post(signingURL, {
            ...data,
            signingBlocks,
            fileName,
            taxCode,
            pdfBase64,
            isCheck
        })
            .then(res => res.data)
            .then(async responseData => {
                if (responseData?.success) {
                    ToastService.success();
                } else if (responseData?.errorMessage || responseData?.message) {
                    if (responseData.agreementId && responseData.partyId && responseData.roleTypeId) {
                        try {
                            await AgreementService.updateSigningError({
                                agreementId: responseData.agreementId,
                                partyId: responseData.partyId,
                                roleTypeId: responseData.roleTypeId,
                                referenceNumber: responseData.referenceNumber || null,
                                signingSecretCode: responseData.signingSecretCode || ''
                            });
                        } catch (apiError) {
                        }
                    }
                    ToastService.error(responseData?.errorMessage || 'Ký số thất bại!');
                }

                // Return the response data along with the signatureLocationList for roleTypeId extraction
                return {
                    ...responseData,
                    signatureLocationList: signingBlocks,
                    agreementId: pulledAgreementId || responseData?.agreementId,
                    partyId: pulledPartyId || responseData?.partyId,
                    roleTypeId: pulledRoleTypeId || responseData?.roleTypeId
                };
            }).catch(async err => {

                if (data.agreementId && data.partyId && data.roleTypeId) {
                    try {
                        await AgreementService.updateSigningError({
                            agreementId: data.agreementId,
                            partyId: data.partyId,
                            roleTypeId: data.roleTypeId,
                            referenceNumber: data.referenceNumber || null,
                            signingSecretCode: data.signingSecretCode || ''
                        });
                        ToastService.error('Ký số thất bại!');
                    } catch (apiError) {
                        ToastService.error('Ký số thất bại!');
                    }
                } else if (data.referenceNumber && data.signingSecretCode) {
                    try {
                        await AgreementService.updateSigningError({
                            referenceNumber: data.referenceNumber,
                            signingSecretCode: data.signingSecretCode,
                            roleTypeId: pulledRoleTypeId || 'PartyA'
                        });
                        ToastService.error('Ký số thất bại!');
                    } catch (apiError) {
                        ToastService.error('Ký số thất bại!');
                    }
                }
                return { success: false, error: err, errorMessage: 'Ký số thất bại!' };
            });
    }
}
